import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { User } from '../models/user';
import { UserRoleViewModel } from '../models/userRoleViewModel';
import { AuthService } from '../services/authService';
import { ActivatedRoute, Router } from '@angular/router';
import { NgModel } from '@angular/forms';
import { catchError, Observable, of } from 'rxjs';

@Component({
    selector: 'app-edit-users-in-role',
    templateUrl: './edit-users-in-role.component.html',
    styleUrl: './edit-users-in-role.component.scss',
    standalone: false
})
export class EditUsersInRoleComponent implements OnInit, AfterViewInit {
  user = new User('', false);
  http!: HttpClient;
  response?: any;
  userRoleViewModels: UserRoleViewModel[] = [];
  roleId!: string;
  @ViewChild('roleName') roleName!: NgModel;
  @ViewChild('roleDescription') roleDescription!: NgModel;

  constructor(
    http: HttpClient,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2
  ) {
    this.http = http;
  }

  public async ngOnInit() {
    // Extract the query parameter;
    this.route.queryParams.subscribe((params) => {
      this.roleId = params['roleId'];
    });
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
    if (isLoggedIn) {
      // use the roleId to call the API and get the role details
      this.getUsersInRole(this.roleId);
    }
  }

  public ngAfterViewInit() {
    // Set the values for the ViewChild elements
    if (this.roleName) {
      this.roleName.control.setValue(this.roleName);
    }
    if (this.roleDescription) {
      this.roleDescription.control.setValue(this.roleDescription);
    }
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? '';
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  public editUsersInRole() {
    // below code was copied in from the edit-role.component.ts file and needs to be updated for this use case

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: '*/*',
    });

    // Create the payload as an object with separate properties
    const payload = {
      userRoleViewModels: this.userRoleViewModels,
      roleId: this.roleId,
    };

    this.http
      .post('/api/Administration/edit_users_in_specified_role', payload, {
        headers: headers,
      })
      .pipe(catchError(this.handleError<any>('editUsersInRole')))
      .subscribe({
        next: (response) => {
          this.response = response;
          if (!response) {
            console.error('response is undefined');
          } else if (response?.success == false) {
            window.alert(
              'We have have one or more errors. Check the console logs.'
            );
            for (const errorMessage of response.errorMessages) {
              console.error(errorMessage);
            }
          } else {
            this.router.navigate(['/edit_role'], {
              queryParams: {
                roleId: this.roleId,
                roleName: this.roleName,
                description: this.roleDescription,
              },
            });
          }
        },
        error: (error) => {
          this.response = error;
          console.error(error.message);
        },
      });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  public async getUsersInRole(roleId: string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    this.http
      .get<any>('/api/Administration/get_users_in_specified_role', {
        headers: headers,
        params: { roleId: roleId },
      })
      .pipe(catchError(this.handleError<any>('getUsersInRole')))
      .subscribe({
        next: (result) => {
          if (result.success === true) {
            this.roleId = result.roleId;
            this.roleName = result.roleName;
            this.roleDescription = result.roleDescription;
            this.userRoleViewModels = result.userRoleViewModels;
          } else {
            if (result.errorMessages) {
              window.alert(
                'We have have one or more errors. Check the console logs.'
              );
              for (const errorMessage of result.errorMessages) {
                console.error(errorMessage);
              }
            }
          }
        },
        error: (error) => console.error(error),
      });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
